// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"i4-z","displaySixCardTiles":"j4-z"};